<template>
  <div class="cache-management">
    <van-nav-bar
      title="缓存管理"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    
    <div class="cache-content">
      <!-- 缓存统计 -->
      <van-cell-group title="缓存统计">
        <van-cell title="内存缓存" :value="cacheStats.memory.size + ' 项'" />
        <van-cell title="IndexedDB资源" :value="cacheStats.indexedDB.resources + ' 项'" />
        <van-cell title="IndexedDB图片" :value="cacheStats.indexedDB.images + ' 项'" />
        <van-cell title="IndexedDB API" :value="cacheStats.indexedDB.api + ' 项'" />
      </van-cell-group>
      
      <!-- 缓存操作 -->
      <van-cell-group title="缓存操作">
        <van-cell
          title="清理过期缓存"
          is-link
          @click="cleanExpiredCache"
        />
        <van-cell
          title="清空所有缓存"
          is-link
          @click="clearAllCache"
        />
        <van-cell
          title="预加载资源"
          is-link
          @click="preloadResources"
        />
      </van-cell-group>
      
      <!-- 缓存详情 -->
      <van-cell-group title="缓存详情" v-if="showDetails">
        <van-cell
          v-for="item in cacheStats.memory.items"
          :key="item"
          :title="item"
          :label="'内存缓存'"
        />
      </van-cell-group>
      
      <!-- 操作按钮 -->
      <div class="action-buttons">
        <van-button
          type="primary"
          size="large"
          @click="refreshStats"
          :loading="loading"
        >
          刷新统计
        </van-button>
        
        <van-button
          type="default"
          size="large"
          @click="toggleDetails"
        >
          {{ showDetails ? '隐藏详情' : '显示详情' }}
        </van-button>
      </div>
    </div>
    
    <!-- 加载提示 -->
    <van-loading v-if="loading" class="loading-overlay" />
  </div>
</template>

<script>
import enhancedCacheManager from '../../common/enhancedCache';

export default {
  name: 'CacheManagement',
  data() {
    return {
      cacheStats: {
        memory: { size: 0, items: [] },
        indexedDB: { resources: 0, images: 0, api: 0 }
      },
      loading: false,
      showDetails: false
    };
  },
  mounted() {
    this.refreshStats();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    
    async refreshStats() {
      this.loading = true;
      try {
        const stats = await enhancedCacheManager.getCacheStats();
        if (stats) {
          this.cacheStats = stats;
        }
      } catch (error) {
        console.error('获取缓存统计失败:', error);
        this.$toast.fail('获取缓存统计失败');
      } finally {
        this.loading = false;
      }
    },
    
    async cleanExpiredCache() {
      this.loading = true;
      try {
        await enhancedCacheManager.cleanExpiredCache();
        this.$toast.success('过期缓存清理完成');
        await this.refreshStats();
      } catch (error) {
        console.error('清理过期缓存失败:', error);
        this.$toast.fail('清理过期缓存失败');
      } finally {
        this.loading = false;
      }
    },
    
    async clearAllCache() {
      try {
        await this.$dialog.confirm({
          title: '确认清空',
          message: '确定要清空所有缓存吗？此操作不可恢复。'
        });
        
        this.loading = true;
        await enhancedCacheManager.clearAllCache();
        this.$toast.success('所有缓存已清空');
        await this.refreshStats();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('清空缓存失败:', error);
          this.$toast.fail('清空缓存失败');
        }
      } finally {
        this.loading = false;
      }
    },
    
    async preloadResources() {
      this.loading = true;
      try {
        // 预加载一些常用资源
        const resourcesToPreload = [
          // 添加一些需要预加载的资源URL
          '/static/css/app.css',
          '/static/js/app.js'
        ];
        
        await enhancedCacheManager.preloadResources(resourcesToPreload);
        this.$toast.success('资源预加载完成');
        await this.refreshStats();
      } catch (error) {
        console.error('预加载资源失败:', error);
        this.$toast.fail('预加载资源失败');
      } finally {
        this.loading = false;
      }
    },
    
    toggleDetails() {
      this.showDetails = !this.showDetails;
    }
  }
};
</script>

<style scoped>
.cache-management {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.cache-content {
  padding: 16px;
}

.action-buttons {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.loading-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.van-cell-group {
  margin-bottom: 16px;
}

.van-cell {
  padding: 12px 16px;
}

.van-cell__title {
  font-size: 14px;
  color: #323233;
}

.van-cell__value {
  font-size: 14px;
  color: #969799;
}

.van-cell__label {
  font-size: 12px;
  color: #c8c9cc;
  margin-top: 4px;
}
</style>
